import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Api from './api'
import AhaPresenter from '@mindthegapstudio/stpancras-storybook-app/src/AhaPresenter'
import PortalVue from 'portal-vue'
import Toasted from 'vue-toasted'

// Need fix momentjs and Bootstrap vue too big size lib

// Filter
import "@/filters"

// Vue Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Vue Click Outside
import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

// Vue Multiple language
import i18n from './i18n'

// Vue toggle button
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

Vue.use(Toasted, { duration: 3000, singleton: true })

// Vue cookie
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

// Vue resources
import VueResource from 'vue-resource'
Vue.use(VueResource)

Api.initResources()

// Import Amin Template
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/custom-style-theme.css'
import '@/assets/scss/fix-theme.scss'
import '@/assets/scss/style.scss'
import './assets/tailwind.css'

Vue.config.productionTip = false

Vue.use(AhaPresenter)
window.AHA_STORYBOOK_VERSION = AhaPresenter.version

Vue.use(PortalVue)

export const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
